export class IntegConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceSharing",
            "baseName": "resourceSharing",
            "type": "DataShareIntegrationConfig",
            "format": ""
        },
        {
            "name": "redshift",
            "baseName": "redshift",
            "type": "RedshiftIntegrationConfig",
            "format": ""
        },
        {
            "name": "bigquery",
            "baseName": "bigquery",
            "type": "BigQueryIntegrationConfig",
            "format": ""
        },
        {
            "name": "snowflake",
            "baseName": "snowflake",
            "type": "SnowflakeIntegrationConfig",
            "format": ""
        },
        {
            "name": "databricks",
            "baseName": "databricks",
            "type": "DatabricksIntegrationConfig",
            "format": ""
        },
        {
            "name": "fabric",
            "baseName": "fabric",
            "type": "MicrosoftFabricIntegrationConfig",
            "format": ""
        },
        {
            "name": "emr",
            "baseName": "emr",
            "type": "EmrIntegrationConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IntegConfig.attributeTypeMap;
    }
    constructor() {
    }
}
